import { expand } from 'uri-template-lite';
import { apiClient } from '../../../common/ApiClient';
import { createApiMutationHook } from '../../../common/queryClient/createApiMutationHook';
import {
  getMutationFn,
  HttpHeaders,
} from '../../../common/queryClient/getMutationFn';
import { AlgorithmUrl } from '../query/AlgorithmUrl';
import {
  AlgorithmFormDataType,
  AlgorithmValidFormDataType,
} from '../schema/types';
import { AlgorithmSchema } from '../schema/AlgorithmSchema';

const postAlgorithm = (
  algorithm: AlgorithmValidFormDataType,
  headers?: HttpHeaders
) =>
  apiClient
    .post<AlgorithmFormDataType>(
      expand(AlgorithmUrl.base, {}),
      AlgorithmSchema.parseMutationDto(algorithm),
      headers ? { headers } : undefined
    )
    .then((response) => response.data);

const putAlgorithm = (
  id: number,
  algorithm: Partial<AlgorithmValidFormDataType>,
  headers?: HttpHeaders
) =>
  apiClient
    .put<AlgorithmFormDataType>(
      expand(AlgorithmUrl.base, { id }),
      AlgorithmSchema.parseMutationDto(algorithm),
      headers ? { headers } : undefined
    )
    .then((response) => response.data);

const deleteAlgorithm = (id: number) =>
  apiClient
    .delete<void>(expand(AlgorithmUrl.base, { id }))
    .then((response) => response.data);

export const useMutateAlgorithmQuery = createApiMutationHook(
  ['algorithm'],
  getMutationFn(postAlgorithm, putAlgorithm, deleteAlgorithm)
);
